import _ from 'underscore'
import React from 'react'
import styled from 'styled-components'

import Tabs, { Tab } from 'components/Tabs'

import FaceplateMessages from 'pages/DeviceAggregator/FaceplateMessages'
import CurrentDeviceState from 'pages/DeviceAggregator/CurrentDeviceState'
import DeviceDetails from 'pages/DeviceAggregator/DeviceDetails'
import Customer from 'pages/DeviceAggregator/Customer'
import MidnightDeviceState from 'pages/DeviceAggregator/MidnightDeviceState'

type Props = {
  deviceId: string
  timeZone: string
}

const TABS = [
  { header: 'Customer Details', detailsComponent: Customer },
  { header: 'Device Details', detailsComponent: DeviceDetails },
  { header: 'Faceplate Messages', detailsComponent: FaceplateMessages },
  { header: 'Device State - Current', detailsComponent: CurrentDeviceState },
  { header: 'Device State - Midnight', detailsComponent: MidnightDeviceState }
]

const DeviceAggregatorTabs = ({ deviceId, timeZone }: Props) => {
  return (
    <Tabs
      tabItems={
        _.map(TABS, r => {
          const item: Tab = {
            key: r.header,
            header: <S.Header>{r.header}</S.Header>,
            details: <r.detailsComponent {...{ deviceId, timeZone }} />
          }

          return item
        })
      }
    />
  )
}

export default DeviceAggregatorTabs

const S = {
  Header: styled.div`
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
    padding: 10px;
  `
}
